import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addBotAllowedUser: botTypes.AddAllowedUser = (data) => {
  return axios.put('/bot/allowed-users', data);
};

type AddBotAllowedUserOptions = {
  config?: MutationConfig<typeof addBotAllowedUser>;
};

export function useAddBotAllowedUser({ config = {} }: AddBotAllowedUserOptions) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['bot-allowed-users']);
      toasts.loadingToast.success('add-bot-allowed-user', 'User name added successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-bot-allowed-user', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-bot-allowed-user', 'Adding user...');
      config.onMutate?.(...args);
    },
    mutationFn: addBotAllowedUser,
  });
}
